import { ErrorLink } from '@apollo/client/link/error';
import { CombinedGraphQLErrors, ServerError } from '@apollo/client/errors';

/**
 * Adapts a v3-style ErrorLink handler ({ graphQLErrors, networkError })
 * to v4's single `error`. Mirrors v3, which also derived graphQLErrors
 * from a ServerError's response body.
 *
 * TODO: remove once errorLink.js reads `error` directly.
 */
export const createErrorLinkCompat = (handler) =>
  new ErrorLink(({ error, operation, forward }) => {
    let graphQLErrors;
    let networkError;

    if (CombinedGraphQLErrors.is(error)) {
      graphQLErrors = error.errors;
    } else if (error) {
      networkError = error;
      if (ServerError.is(error)) {
        try { graphQLErrors = JSON.parse(error.bodyText)?.errors; } catch { /* not JSON */ }
      }
    }

    return handler({ graphQLErrors, networkError, operation, forward });
  });
